import Api from '../../services/Api';
import Helpers from '../../js/helpers';

const getDefaultState = () => ({
  resultProject: null,
  enabledPopUpSensor: false,
  enabledPopUpCorrectiveNitrogenManagement: false,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetResultState({ commit }) {
      commit('resetResultState');
    },
    async loadResult(context, id) {
      try {
        const xhr = await Api.getResultProject(id);
        const listResult = JSON.parse(xhr.response);
        context.commit('setResultProject', listResult);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    setEnabledPopUpSensor(context, value) {
      context.commit('setEnabledPopUpSensor', value);
    },
    setEnabledPopUpCorrectiveNitrogenManagement(context, value) {
      context.commit('setEnabledPopUpCorrectiveNitrogenManagement', value);
    },
    resetResult(context) {
      context.commit('setResultProject', null);
    },
  },
  mutations: {
    resetResultState(state) {
      Object.assign(state, getDefaultState());
    },
    setResultProject(state, value) {
      state.resultProject = value;
    },
    setEnabledPopUpSensor(state, value) {
      state.enabledPopUpSensor = value;
    },
    setEnabledPopUpCorrectiveNitrogenManagement(state, value) {
      state.enabledPopUpCorrectiveNitrogenManagement = value;
    },
  },
};
